import { CountryCode } from "./CountryCode";

export enum TenantCode {
	JBH_AU = "jbh-au",
	JBH_NZ = "jbh-nz",
}

export const COMPANY_CODE = "JBH";

export function getTenantFromPath(pathname: string): TenantCode | null {
	const segments = pathname.split('/').filter(segment => segment.length > 0);
	const firstSegment = segments[0];
	
	if (Object.values(TenantCode).includes(firstSegment as TenantCode)) {
		return firstSegment as TenantCode;
	}
	
	return null;
}

export function countryCodeToTenantCode(countryCode: CountryCode): TenantCode {
	switch (countryCode) {
		case CountryCode.AU:
			return TenantCode.JBH_AU;
		case CountryCode.NZ:
			return TenantCode.JBH_NZ;
		default:
			return TenantCode.JBH_AU; // Default to AU
	}
}

export function tenantCodeToCountryCode(tenantCode: TenantCode): CountryCode {
	switch (tenantCode) {
		case TenantCode.JBH_AU:
			return CountryCode.AU;
		case TenantCode.JBH_NZ:
			return CountryCode.NZ;
		default:
			return CountryCode.AU; // Default to AU
	}
}

export function removeTenantFromPath(pathname: string): string {
	const tenant = getTenantFromPath(pathname);
	if (tenant) {
		return pathname.replace(`/${tenant}`, '') || '/';
	}
	return pathname;
}


export function addTenantToPath(pathname: string, tenantCode: TenantCode): string {
	// Remove existing tenant if present
	const cleanPath = removeTenantFromPath(pathname);
	
	// Add new tenant
	if (cleanPath === '/') {
		return `/${tenantCode}`;
	}
	
	return `/${tenantCode}${cleanPath}`;
}